<script>
  import { user } from '../stores/authStore';

  let dismissed = false;

  $: subscription = $user?.subscription || null;
  $: trialEndDate = subscription?.trialEndDate || null;
  $: trialWarningDays = subscription?.trialWarningDays || 14;

  $: daysRemaining = (() => {
    if (!trialEndDate) return null;
    const end = new Date(trialEndDate);
    const now = new Date();
    return Math.max(0, Math.ceil((end - now) / (1000 * 60 * 60 * 24)));
  })();

  $: showBanner = !dismissed
    && !$user?.coveredByOrganisation
    && subscription
    && (!subscription.status || subscription.status === 'trial')
    && trialEndDate
    && daysRemaining !== null
    && daysRemaining <= trialWarningDays;

  function dismiss() {
    dismissed = true;
  }
</script>

{#if showBanner}
  <div class="bg-amber-50 border-b border-amber-200 px-4 py-3">
    <div class="flex items-center justify-between max-w-7xl mx-auto">
      <p class="text-sm font-medium text-orange-600">
        Your trial ends in <span class="font-bold">{daysRemaining}</span> day{daysRemaining !== 1 ? 's' : ''}.
        <a href="/settings" class="underline hover:text-orange-800 ml-1">Click here to see plans</a>
      </p>
      <button
        on:click={dismiss}
        class="ml-4 text-orange-400 hover:text-orange-600 focus:outline-none"
        aria-label="Dismiss"
      >
        <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  </div>
{/if}
